import { ComponentF } from "../../../ui/ui";
import { isCharAvailable } from "../../words/wordUtils";
import { buildFixedTextPromptString, buildLetterString } from "./WordUIHelpers";

export const LetterSelectInput: ComponentF<{
  letters: string[];
  spellWand: string[];
  max: number;
  upperCase: boolean;
  onUpdateLetters: (letters: string[]) => void;
}> = (C, props) => {
  const max = props.max || 1;

  C.handlers.keypress = (key: string) => {
    if (key === "Backspace" || key == "Delete") {
      props.onUpdateLetters(props.letters.slice(0, props.letters.length - 1));
      return true;
    }
    const casedKey = props.upperCase
      ? key.toLocaleUpperCase()
      : key.toLocaleLowerCase();

    if (
      props.letters.length < max &&
      isCharAvailable(casedKey, props.letters, props.spellWand)
    ) {
      props.onUpdateLetters([...props.letters, casedKey]);
      return true;
    }
    return true; //Is this right?
  };

  C.display.drawText(
    C.bounds.x + Math.floor(C.bounds.w / 2 - props.spellWand.length / 2),
    C.bounds.y,
    buildLetterString(props.spellWand, props.letters)
  );

  C.display.drawText(
    C.bounds.x + Math.floor(C.bounds.w / 2 - max / 2),
    C.bounds.y + 2,
    buildFixedTextPromptString(props.letters, max)
  );
};
